import { IDEE, RIEN_DEDANS } from '../partage/vocabulaire';
import './DessinsDUneBulle.css';

/*
 * Les petits dessins d'une bulle, partagés par la ligne de la Liste (`Bulle.tsx`), le nœud de
 * la Carte (`NoeudCarte.tsx`) et celui de la Hiérarchie (`NoeudHierarchie.tsx`). Le rond d'un
 * état est à part, dans `PastilleEtat.tsx`.
 */

/**
 * Jamais ouverte (« Rien dedans » à l'écran) : un cercle en POINTILLÉ, et pas le cercle plein
 * de « à faire ». Le pointillé est, partout dans le dessin, ce qui n'a jamais été ouvert : lui
 * donner le trait plein reviendrait à dire qu'on a déjà regardé dedans. C'est une marque, pas
 * un gris : le titre, lui, reste à pleine encre (retour 4 des testeurs).
 */
export function PastilleJamaisOuverte({ taille = 19 }: { taille?: number }) {
  return (
    <svg
      className="pastille-etat"
      width={taille}
      height={taille}
      viewBox="0 0 16 16"
      fill="none"
      aria-label={RIEN_DEDANS}
    >
      <circle
        cx="8"
        cy="8"
        r="7.2"
        stroke="var(--trait-pointille)"
        strokeWidth="1.4"
        strokeDasharray="2.4 2.8"
      />
    </svg>
  );
}

/**
 * Ce qu'une bulle contient, en points. Un point par chose, jamais un nombre : « 4 dedans »
 * se lit, les points se voient — et c'est un poids qu'on soupèse, pas une donnée qu'on lit.
 * Au-delà de six, on cesse de compter à l'œil de toute façon.
 */
export function PointsDeContenu({ combien }: { combien: number }) {
  if (combien <= 0) return null;
  return (
    <span className="points-contenu" aria-label={`${combien} dedans`}>
      {Array.from({ length: Math.min(combien, 6) }, (_, i) => (
        <span key={i} aria-hidden="true" />
      ))}
    </span>
  );
}

/** Une idée, dans la Liste : un carré, comme la maquette (`design/liste.html`). */
export function CarreDIdee() {
  return (
    <svg className="pastille-etat" width={19} height={19} viewBox="0 0 16 16" fill="none" aria-label={IDEE}>
      <rect x="1.2" y="1.2" width="13.6" height="13.6" rx="3" stroke="var(--encre-tenue)" strokeWidth="1.6" />
    </svg>
  );
}

/** Le chevron d'une étape dans la Liste : à droite fermée, vers le bas dépliée (maquette `liste.html`). */
export function ChevronDeLEtape({ deplie }: { deplie: boolean }) {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d={deplie ? 'M6 9l6 6 6-6' : 'M9 6l6 6-6 6'}
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
